export const title = 'Add a new team member';
export const description =
	'This team member will receive all notifications for all listings and services on your account. If you would like to add someone to a single listing, such as a homeowner, you can add them from within the service itself.';
export const add = 'add';
export const addTeamMemberErrorMessage = 'Please fill out each field';
